import { render } from "./classificationStatistics.vue?vue&type=template&id=f9ef4aa8&scoped=true"
import script from "./classificationStatistics.vue?vue&type=script&lang=js"
export * from "./classificationStatistics.vue?vue&type=script&lang=js"

import "./classificationStatistics.vue?vue&type=style&index=0&id=f9ef4aa8&lang=scss"
import "./classificationStatistics.vue?vue&type=style&index=1&id=f9ef4aa8&scoped=true&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ef4aa8"]])

export default __exports__